import type { auth } from "@clutch/auth";
import { organizationAc, organizationRoles } from "@clutch/auth/rbac";
import {
	adminClient,
	inferAdditionalFields,
	organizationClient,
	phoneNumberClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
	plugins: [
		inferAdditionalFields<typeof auth>(),
		adminClient(),
		phoneNumberClient(),
		organizationClient({
			ac: organizationAc,
			roles: organizationRoles,
			// Dormant org-team client wiring for a future productized workspace team flow.
			// teams: {
			// 	enabled: true,
			// },
		}),
	],
});
